import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, getCurrentInstance } from "vue";
import CloseCircleOutlineIcon from "icons/CloseCircleOutline.vue";
import store from "@/store";
import { NolaAnalytics, NolaItemId, NolaContentType } from "@/lib/utils/analytics";


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentFeaturePromotionBanner',
  props: {
    detail: null
  },
  emits: ["banner-click"],
  setup(__props: any, { emit }) {





const instance = getCurrentInstance();
const nolaAnalytics = new NolaAnalytics(instance?.proxy.$gtm!, store);

const isVisible = ref(true);

const onClickBanner = () => {
  emit("banner-click");
  isVisible.value = false;
  updateDisplayedFlag();
  nolaAnalytics.logButtonEvent(NolaItemId.AgentFeaturePromotionBanner);
};

const closeBanner = () => {
  isVisible.value = false;
  updateDisplayedFlag();
  nolaAnalytics.logButtonEvent(NolaItemId.AgentFeaturePromotionBannerClose);
};

const updateDisplayedFlag = () => {
  if (!store.getters["generalModule/hasUsedAgentFeaturePromoBanner"]) {
    // 本コンポーネント利用済みフラグを立てる
    store.dispatch("generalModule/setUsedAgentFeaturePromoBanner", true);
  }
};

onMounted(async () => {
  nolaAnalytics.logViewItemEvent(NolaItemId.AgentFeaturePromotionBanner, NolaContentType.Banner);
});

return { __sfc: true,emit, instance, nolaAnalytics, isVisible, onClickBanner, closeBanner, updateDisplayedFlag, CloseCircleOutlineIcon }
}

})